import { STARTER, ENTERPRISE } from 'pricing-pages-ui/constants/routing/Tabs';
const BASE_URL = 'https://www.hubspot.com/hubfs';

const getImageUrl = extension => BASE_URL + extension;

const CompanyProofs = {
  Landytech: {
    name: 'Landytech',
    icon: getImageUrl('/Company%20Proof/Landytech.svg')
  },
  EV_Construction: {
    name: 'EV Construction',
    icon: getImageUrl('/Company%20Proof/EV%20Construction.jpg')
  },
  Q4intelligence_LLC: {
    name: 'Q4 Intelligence',
    icon: getImageUrl('/Company%20Proof/Q4intelligence%2c%20LLC.png')
  },
  SRS_Distribution: {
    name: 'SRS Distribution',
    icon: getImageUrl('/Company%20Proof/SRS%20Distribution.png')
  },
  Grow_Group_PLC: {
    name: 'Grow Group',
    icon: getImageUrl('/Company%20Proof/Grow%20Group%20PLC.svg')
  },
  I_Janvey_and_Sons: {
    name: 'I. Janvey and Sons',
    icon: getImageUrl('/Company%20Proof/I.%20Janvey%20and%20Sons.jpg')
  },
  At_Sunrice_GlobalChef_Academy_Pte_Ltd: {
    name: 'At-Sunrice Global Chef Academy',
    icon: getImageUrl('/Company%20Proof/At-Sunrice%20GlobalChef%20Academy%20Pte%20Ltd.png')
  },
  G_L_Scientific: {
    name: 'G&L Scientific',
    icon: getImageUrl('/Company%20Proof/G_L%20Scientific.svg')
  },
  Airstream: {
    name: 'Airstream',
    icon: getImageUrl('/Company%20Proof/airstream-logo.svg')
  },
  DoorDash: {
    name: 'DoorDash',
    icon: getImageUrl('/Company%20Proof/doordash-logo.png')
  },
  Loom: {
    name: 'Loom',
    icon: getImageUrl('/Company%20Proof/Loom_logo.png')
  },
  RSR_Acquisition_LLC: {
    name: 'Reseller Ratings',
    icon: getImageUrl('/Company%20Proof/RSR%20Acquisition%2c%20LLC.svg')
  },
  Avison_Young: {
    name: 'Avison Young',
    icon: getImageUrl('/Company%20Proof/Avison%20Young.svg')
  },
  The_Linux_Foundation: {
    name: 'The Linux Foundation',
    icon: getImageUrl('/Company%20Proof/The%20Linux%20Foundation.svg')
  },
  WWF_World_Wide_Fund_For_Nature: {
    name: 'WWF',
    icon: getImageUrl('/Company%20Proof/WWF%20World%20Wide%20Fund%20For%20Nature.png')
  },
  VMware: {
    name: 'VMware',
    icon: getImageUrl('/Company%20Proof/VMware.png')
  }
};
export const CompanyProofsMap = {
  [STARTER]: [CompanyProofs.Landytech, CompanyProofs.EV_Construction, CompanyProofs.Q4intelligence_LLC, CompanyProofs.SRS_Distribution, CompanyProofs.Grow_Group_PLC, CompanyProofs.I_Janvey_and_Sons, CompanyProofs.At_Sunrice_GlobalChef_Academy_Pte_Ltd, CompanyProofs.G_L_Scientific],
  [ENTERPRISE]: [CompanyProofs.Airstream, CompanyProofs.DoorDash, CompanyProofs.Loom, CompanyProofs.RSR_Acquisition_LLC, CompanyProofs.Avison_Young, CompanyProofs.The_Linux_Foundation, CompanyProofs.WWF_World_Wide_Fund_For_Nature, CompanyProofs.VMware]
};